"use client"

import { useConfig } from "@packages/web/components/ConfigProvider"

export default function Footer() {
  const { COMPANY_CONTACT_EMAIL, COMPANY_NAME } = useConfig()
  return (
    <footer className="bg-background py-2">
      <div className="container mx-auto px-4">
        <div className="border-t border-border/30 pt-2 text-center md:text-left">
          <div className="flex flex-col md:flex-row justify-between items-center gap-2">
            <p className="text-foreground/30 text-xs md:text-sm">
              &copy; {new Date().getFullYear()} {COMPANY_NAME}. All rights reserved.
            </p>
            <div className="flex space-x-4 justify-center md:justify-end">
              <a href="/about" className="text-foreground/30 hover:text-tertiary-base text-xs transition-colors">
                About
              </a>
              <a href="/privacy" className="text-foreground/30 hover:text-tertiary-base text-xs transition-colors">
                Privacy
              </a>
              <a href="/terms" className="text-foreground/30 hover:text-tertiary-base text-xs transition-colors">
                Terms
              </a>
              <a href={`mailto:${COMPANY_CONTACT_EMAIL}`} className="text-foreground/30 hover:text-tertiary-base text-xs transition-colors">
                Contact
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}
